module.exports = __webpack_public_path__ + "media/images/iconPaginatePrev__okGreen-7fbef2056d976bf968f11340bd7e08ef.png";